import { LocationOption, AreaData } from '../types';

// City options - only New York available
export const cities: LocationOption[] = [
  { value: '', label: 'Select City' },
  { value: 'new-york', label: 'New York' },
];

// NYC Boroughs and Jersey City without empty options
export const boroughs: LocationOption[] = [
  { value: 'manhattan', label: 'Manhattan' },
  { value: 'brooklyn', label: 'Brooklyn' },
  { value: 'queens', label: 'Queens' },
  { value: 'bronx', label: 'Bronx' },
  { value: 'staten-island', label: 'Staten Island' },
  { value: 'jersey-city', label: 'Jersey City' },
];

// Extended neighborhoods - removed empty "Select Neighborhood" options
export const neighborhoods: AreaData = {
  manhattan: [
    { value: 'upper-east-side', label: 'Upper East Side' },
    { value: 'upper-west-side', label: 'Upper West Side' },
    { value: 'midtown-east', label: 'Midtown East' },
    { value: 'midtown-west', label: 'Midtown West' },
    { value: 'chelsea', label: 'Chelsea' },
    { value: 'greenwich-village', label: 'Greenwich Village' },
    { value: 'east-village', label: 'East Village' },
    { value: 'west-village', label: 'West Village' },
    { value: 'soho', label: 'SoHo' },
    { value: 'tribeca', label: 'Tribeca' },
    { value: 'nolita', label: 'Nolita' },
    { value: 'little-italy', label: 'Little Italy' },
    { value: 'chinatown', label: 'Chinatown' },
    { value: 'lower-east-side', label: 'Lower East Side' },
    { value: 'financial-district', label: 'Financial District' },
    { value: 'battery-park', label: 'Battery Park City' },
    { value: 'harlem', label: 'Harlem' },
    { value: 'east-harlem', label: 'East Harlem' },
    { value: 'washington-heights', label: 'Washington Heights' },
    { value: 'inwood', label: 'Inwood' },
    { value: 'morningside-heights', label: 'Morningside Heights' },
    { value: 'hamilton-heights', label: 'Hamilton Heights' },
    { value: 'hells-kitchen', label: 'Hell\'s Kitchen' },
    { value: 'gramercy', label: 'Gramercy Park' },
    { value: 'flatiron', label: 'Flatiron District' },
    { value: 'murray-hill', label: 'Murray Hill' },
    { value: 'kips-bay', label: 'Kips Bay' },
    { value: 'stuyvesant-town', label: 'Stuyvesant Town' },
  ],
  brooklyn: [
    { value: 'williamsburg', label: 'Williamsburg' },
    { value: 'greenpoint', label: 'Greenpoint' },
    { value: 'park-slope', label: 'Park Slope' },
    { value: 'brooklyn-heights', label: 'Brooklyn Heights' },
    { value: 'dumbo', label: 'DUMBO' },
    { value: 'prospect-heights', label: 'Prospect Heights' },
    { value: 'carroll-gardens', label: 'Carroll Gardens' },
    { value: 'cobble-hill', label: 'Cobble Hill' },
    { value: 'boerum-hill', label: 'Boerum Hill' },
    { value: 'fort-greene', label: 'Fort Greene' },
    { value: 'clinton-hill', label: 'Clinton Hill' },
    { value: 'red-hook', label: 'Red Hook' },
    { value: 'sunset-park', label: 'Sunset Park' },
    { value: 'bay-ridge', label: 'Bay Ridge' },
    { value: 'dyker-heights', label: 'Dyker Heights' },
    { value: 'bushwick', label: 'Bushwick' },
    { value: 'bedford-stuyvesant', label: 'Bedford-Stuyvesant' },
    { value: 'crown-heights', label: 'Crown Heights' },
    { value: 'prospect-lefferts', label: 'Prospect Lefferts Gardens' },
    { value: 'windsor-terrace', label: 'Windsor Terrace' },
    { value: 'kensington', label: 'Kensington' },
    { value: 'ditmas-park', label: 'Ditmas Park' },
    { value: 'flatbush', label: 'Flatbush' },
    { value: 'gowanus', label: 'Gowanus' },
    { value: 'crown-heights-north', label: 'Crown Heights North' },
    { value: 'brownsville', label: 'Brownsville' },
    { value: 'east-new-york', label: 'East New York' },
    { value: 'bensonhurst', label: 'Bensonhurst' },
    { value: 'sheepshead-bay', label: 'Sheepshead Bay' },
  ],
  queens: [
    { value: 'astoria', label: 'Astoria' },
    { value: 'long-island-city', label: 'Long Island City' },
    { value: 'sunnyside', label: 'Sunnyside' },
    { value: 'woodside', label: 'Woodside' },
    { value: 'elmhurst', label: 'Elmhurst' },
    { value: 'jackson-heights', label: 'Jackson Heights' },
    { value: 'corona', label: 'Corona' },
    { value: 'flushing', label: 'Flushing' },
    { value: 'forest-hills', label: 'Forest Hills' },
    { value: 'rego-park', label: 'Rego Park' },
    { value: 'kew-gardens', label: 'Kew Gardens' },
    { value: 'ridgewood', label: 'Ridgewood' },
    { value: 'middle-village', label: 'Middle Village' },
    { value: 'glendale', label: 'Glendale' },
    { value: 'bayside', label: 'Bayside' },
    { value: 'whitestone', label: 'Whitestone' },
    { value: 'college-point', label: 'College Point' },
    { value: 'fresh-meadows', label: 'Fresh Meadows' },
    { value: 'jamaica', label: 'Jamaica' },
    { value: 'richmond-hill', label: 'Richmond Hill' },
    { value: 'ozone-park', label: 'Ozone Park' },
    { value: 'howard-beach', label: 'Howard Beach' },
    { value: 'rockaway', label: 'Rockaway' },
    { value: 'maspeth', label: 'Maspeth' },
    { value: 'east-elmhurst', label: 'East Elmhurst' },
  ],
  bronx: [
    { value: 'mott-haven', label: 'Mott Haven' },
    { value: 'port-morris', label: 'Port Morris' },
    { value: 'melrose', label: 'Melrose' },
    { value: 'morrisania', label: 'Morrisania' },
    { value: 'hunts-point', label: 'Hunts Point' },
    { value: 'longwood', label: 'Longwood' },
    { value: 'highbridge', label: 'Highbridge' },
    { value: 'concourse', label: 'Grand Concourse' },
    { value: 'tremont', label: 'Tremont' },
    { value: 'belmont', label: 'Belmont' },
    { value: 'fordham', label: 'Fordham' },
    { value: 'university-heights', label: 'University Heights' },
    { value: 'morris-heights', label: 'Morris Heights' },
    { value: 'kingsbridge', label: 'Kingsbridge' },
    { value: 'riverdale', label: 'Riverdale' },
    { value: 'fieldston', label: 'Fieldston' },
    { value: 'pelham-bay', label: 'Pelham Bay' },
    { value: 'city-island', label: 'City Island' },
    { value: 'co-op-city', label: 'Co-op City' },
    { value: 'morris-park', label: 'Morris Park' },
    { value: 'westchester-square', label: 'Westchester Square' },
    { value: 'parkchester', label: 'Parkchester' },
    { value: 'soundview', label: 'Soundview' },
    { value: 'castle-hill', label: 'Castle Hill' },
    { value: 'throggs-neck', label: 'Throggs Neck' },
  ],
  'staten-island': [
    { value: 'st-george', label: 'St. George' },
    { value: 'tompkinsville', label: 'Tompkinsville' },
    { value: 'stapleton', label: 'Stapleton' },
    { value: 'clifton', label: 'Clifton' },
    { value: 'rosebank', label: 'Rosebank' },
    { value: 'new-brighton', label: 'New Brighton' },
    { value: 'west-brighton', label: 'West Brighton' },
    { value: 'port-richmond', label: 'Port Richmond' },
    { value: 'mariners-harbor', label: "Mariner's Harbor" },
    { value: 'elm-park', label: 'Elm Park' },
    { value: 'dongan-hills', label: 'Dongan Hills' },
    { value: 'richmond-valley', label: 'Richmond Valley' },
    { value: 'tottenville', label: 'Tottenville' },
    { value: 'great-kills', label: 'Great Kills' },
    { value: 'eltingville', label: 'Eltingville' },
    { value: 'annadale', label: 'Annadale' },
    { value: 'woodrow', label: 'Woodrow' },
    { value: 'huguenot', label: 'Huguenot' },
    { value: 'charleston', label: 'Charleston' },
    { value: 'rossville', label: 'Rossville' },
  ],
  'jersey-city': [
    { value: 'downtown-jc', label: 'Downtown Jersey City' },
    { value: 'newport', label: 'Newport' },
    { value: 'paulus-hook', label: 'Paulus Hook' },
    { value: 'exchange-place', label: 'Exchange Place' },
    { value: 'harborside', label: 'Harborside' },
    { value: 'the-heights', label: 'The Heights' },
    { value: 'journal-square', label: 'Journal Square' },
    { value: 'mcginley-square', label: 'McGinley Square' },
    { value: 'greenville', label: 'Greenville' },
    { value: 'bergen-lafayette', label: 'Bergen-Lafayette' },
    { value: 'west-side', label: 'West Side' },
    { value: 'marion', label: 'Marion' },
    { value: 'liberty-harbor', label: 'Liberty Harbor' },
    { value: 'van-vorst-park', label: 'Van Vorst Park' },
    { value: 'hamilton-park', label: 'Hamilton Park' },
    { value: 'harsimus-cove', label: 'Harsimus Cove' },
    { value: 'powerhouse', label: 'Powerhouse Arts District' },
    { value: 'indian-square', label: 'India Square' },
    { value: 'five-corners', label: 'Five Corners' },
    { value: 'communipaw', label: 'Communipaw' },
    { value: 'society-hill', label: 'Society Hill' },
    { value: 'lafayette', label: 'Lafayette' },
    { value: 'ocean-avenue', label: 'Ocean Avenue' },
  ],
};